






import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GTrimString',
  props: {
    maxLength: {
      type: Number as PropType<number>,
    },
    text: {
      type: String as PropType<string>,
    },
  },
  computed: {
    displayText() {
      const isOverLength = this.text.length > this.maxLength;
      const trimText = isOverLength
        ? `${this.text.slice(0, this.maxLength)}…`
        : this.text;
      return trimText;
    },
  },
});
